module.exports = __webpack_public_path__ + "static/img/gaozhonghuaxue3.1776b657.jpg";